import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import entities from "entities";

import { Divider, IconButton, Collapse } from "@material-ui/core";
import {
  KeyboardArrowDown as KeyboardArrowDownIcon,
  KeyboardArrowUp as KeyboardArrowUpIcon
} from "@material-ui/icons";

import brightcovePlayerLoader from "@brightcove/player-loader";
import { isSafari } from "react-device-detect";

import Analytics from "../../../../helpers/analytics";
import { Mixpanel } from "../../../../components/shared/Mixpanel";

import Recommended from "./RecommendedInPlayer";
import Toolbar from "./PlayerToolbar";
import VideoDetails from "./VideoDetails";

import Tags from "./Tags";

import VideoPlayerWrapper from "./styles/VideoPlayer.style";

function VideoPlayer(props) {
  const [videoEnd, setVideoEnd] = useState(false);
  const [open, setOpen] = useState({
    description: false,
    tags: false
  });
  const {
    auth,
    addFavorite,
    addToCart,
    clearAllSearch,
    recommended,
    removeFavorite,
    removeFromCart,
    user,
    video,
    additionalInfo,
    sendViewEvent,
    isMobile
  } = props;
  const { brightCoveVideoId, imgUrl, publishingDescription } = video;
  const setKeyFrames = (duration) => {
    let percent = (duration / 10).toFixed(0);
    sessionStorage.setItem("one", percent);
    sessionStorage.setItem("two", (percent * 2).toFixed(0));
    sessionStorage.setItem("three", (percent * 3).toFixed(0));
    sessionStorage.setItem("four", (percent * 4).toFixed(0));
    sessionStorage.setItem("five", (percent * 5).toFixed(0));
    sessionStorage.setItem("six", (percent * 6).toFixed(0));
    sessionStorage.setItem("seven", (percent * 7).toFixed(0));
    sessionStorage.setItem("eight", (percent * 8).toFixed(0));
    sessionStorage.setItem("nine", (percent * 9).toFixed(0));
  };

  useEffect(() => {
    sendViewEvent(video.jmId);
    brightcovePlayerLoader.reset();
    brightcovePlayerLoader({
      refNode: "#brightcoveVideo",
      accountId: process.env.REACT_APP_BRIGHTCOVE_ACCOUNT_ID,
      playerId: process.env.REACT_APP_BRIGHTCOVE_PLAYER_ID,
      embedId: "default",
      videoId: brightCoveVideoId,
      onSuccess: (success) => {
        if (!isSafari) {
          success.ref.play();
        }

        success.ref.on("play", () => {
          setVideoEnd(false);
          Analytics.track("Video Played", {
            category: "LP-VideoDetail",
            label: video.jmId
          });
          setKeyFrames(video.duration);
          Mixpanel.track("Video play", {
            JVID: video.jmId
          });
        });

        success.ref.on("pause", () => {
          Analytics.track("Video Paused", {
            category: "LP-VideoDetail",
            label: video.jmId
          });
          Mixpanel.track("Video paused", {
            JVID: video.jmId
          });
        });

        success.ref.on("ended", () => {
          Analytics.track("Video Ended", {
            category: "LP-VideoDetail",
            label: video.jmId
          });
          Mixpanel.track("Video ended", {
            JVID: video.jmId
          });
          setVideoEnd(true);
        });

        success.ref.on("timeupdate", (evt) => {
          let curTime = 0;
          if (evt.target.children[0] !== undefined) {
            // eslint-disable-next-line
            curTime = parseInt(evt.target.children[0].currentTime * 10).toFixed(0);
          }

          switch (curTime) {
            case sessionStorage.getItem("one"):
              Analytics.track("10% video played", {
                category: "LP-VideoDetail",
                label: video.jmId
              });
              return sessionStorage.setItem("one", null);

            case sessionStorage.getItem("two"):
              Analytics.track("20% video played", {
                category: "LP-VideoDetail",
                label: video.jmId
              });
              return sessionStorage.setItem("two", null);

            case sessionStorage.getItem("three"):
              Analytics.track("30% video played", {
                category: "LP-VideoDetail",
                label: video.jmId
              });
              return sessionStorage.setItem("three", null);

            case sessionStorage.getItem("four"):
              Analytics.track("40% video played", {
                category: "LP-VideoDetail",
                label: video.jmId
              });
              return sessionStorage.setItem("four", null);

            case sessionStorage.getItem("five"):
              Analytics.track("50% video played", {
                category: "LP-VideoDetail",
                label: video.jmId
              });
              return sessionStorage.setItem("five", null);

            case sessionStorage.getItem("six"):
              Analytics.track("60% video played", {
                category: "LP-VideoDetail",
                label: video.jmId
              });
              return sessionStorage.setItem("six", null);

            case sessionStorage.getItem("seven"):
              Analytics.track("70% video played", {
                category: "LP-VideoDetail",
                label: video.jmId
              });
              return sessionStorage.setItem("seven", null);

            case sessionStorage.getItem("eight"):
              Analytics.track("80% video played", {
                category: "LP-VideoDetail",
                label: video.jmId
              });
              return sessionStorage.setItem("eight", null);

            case sessionStorage.getItem("nine"):
              Analytics.track("90% video played", {
                category: "LP-VideoDetail",
                label: video.jmId
              });
              return sessionStorage.setItem("nine", null);
            default:
              return null;
          }
        });
      },
      onFailure: (failure) => {}
    });
    return () => {
      brightcovePlayerLoader.reset();
    };
  }, [brightCoveVideoId]);

  return (
    <VideoPlayerWrapper>
      <div>
        {videoEnd && recommended && (
          <Recommended
            recommended={recommended}
            user={user}
            addToCart={addToCart}
            removeFromCart={removeFromCart}
            addFavorite={addFavorite}
            removeFavorite={removeFavorite}
          />
        )}

        {brightCoveVideoId ? (
          <div className="player__wrapper">
            <div className="player__container" style={{ paddingTop: "56.25%" }}>
              <div id="brightcoveVideo" className="videoDetailBox" />
            </div>
          </div>
        ) : (
          <img className="video-player" src={imgUrl} alt="video" />
        )}
      </div>

      <Toolbar {...props} />

      {isMobile && (
        <VideoDetails
          video={video}
          isMobile={isMobile}
          additionalInfo={additionalInfo}
          auth={auth}
        />
      )}

      {!isMobile && (
        <p className="video--description">
          {entities.decodeHTML(
            publishingDescription.replace(/<br ?\/?>/gi, "\n").replace(/(<([^>]+)>)|&nbsp;/gi, "")
          )}
        </p>
      )}

      {!isMobile && video.tags && video.tags.length > 0 && (
        <Tags tags={video.tags} clearAllSearch={clearAllSearch} />
      )}

      {isMobile && (
        <div
          className="mobile__collapse mobile__description"
          onClick={() => setOpen((prev) => ({ ...prev, description: !prev.description }))}
        >
          <div>Description</div>
          <IconButton>
            {!open.description ? (
              <KeyboardArrowDownIcon className="history__table__row--icon-download" />
            ) : (
              <KeyboardArrowUpIcon className="history__table__row--icon-download" />
            )}
          </IconButton>
        </div>
      )}

      <Collapse in={open.description} timeout="auto" unmountOnExit>
        <p className="video--description">
          {entities.decodeHTML(
            publishingDescription.replace(/<br ?\/?>/gi, "\n").replace(/(<([^>]+)>)|&nbsp;/gi, "")
          )}
        </p>
      </Collapse>

      {isMobile && (
        <div
          className="mobile__collapse mobile__tags"
          onClick={() => setOpen((prev) => ({ ...prev, tags: !prev.tags }))}
        >
          <div>Tags</div>
          <IconButton>
            {!open.tags ? (
              <KeyboardArrowDownIcon className="history__table__row--icon-download" />
            ) : (
              <KeyboardArrowUpIcon className="history__table__row--icon-download" />
            )}
          </IconButton>
        </div>
      )}

      <Collapse in={open.tags} timeout="auto" unmountOnExit>
        {video.tags && video.tags.length > 0 && (
          <Tags tags={video.tags} clearAllSearch={clearAllSearch} />
        )}
      </Collapse>

      {!isMobile && <Divider />}
    </VideoPlayerWrapper>
  );
}

VideoPlayer.propTypes = {
  video: PropTypes.object
};

export default VideoPlayer;
